<template>
  <!-- 资源库管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dataBase"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dataBase" leftIndex="dataBseManage"></LeftSideBar>
    </div>

    <div id="deptContentBox" class="base-content">
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新增</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="preCheck('toEdit')"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="preCheck('toDelete')"
          >删除</el-button
        >
      </div>

      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-customClass="loadingStyles"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
        @selection-change="handleTableSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="资源库名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sourceInfo.name"
          show-overflow-tooltip
          label="来源"
          align="center"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="类型" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.type == 10">百科条目</p>
            <p v-if="scope.row.type == 20">辞典工具书</p>
            <p v-if="scope.row.type == 30">专项数据</p>
            <p v-if="scope.row.type == 40">图书</p>
            <p v-if="scope.row.type == 50">图片</p>
            <p v-if="scope.row.type == 60">音频</p>
            <p v-if="scope.row.type == 70">视频</p>
            <p v-if="scope.row.type == 80">图片集</p>
            <p v-if="scope.row.type == 90">音频集</p>
            <p v-if="scope.row.type == 100">视频集</p>
            <p v-if="scope.row.type == 110">3D动画</p>
            <p v-if="scope.row.type == 120">论文</p>
            <p v-if="scope.row.type == 130">文章</p>
            <p v-if="scope.row.type == 140">问答对</p>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="备注" align="center">
        </el-table-column>
      </el-table>
      <!-- 主列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增资源库弹窗 -->
    <el-dialog
      title="新增资源库"
      :visible.sync="createDialog"
      width="600px"
      @open="noClick = false"
    >
      <el-form ref="addDBForm" :model="addDBForm" :rules="addDBRules">
        <el-form-item label="资源库名称：" label-width="100px">
          <el-input
            v-model="addDBForm.name"
            style="max-width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="来源：" label-width="100px">
          <el-select v-model="addDBForm.sourceId" clearable>
            <el-option
              v-for="item in sourceList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" label-width="100px">
          <el-select v-model="addDBForm.type" clearable>
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" label-width="100px">
          <el-input
            type="textarea"
            v-model="addDBForm.remark"
            style="max-width: 400px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCreate('addDBForm')"
          >确 定</el-button
        >
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑资源库弹窗 -->
    <el-dialog title="编辑资源库" :visible.sync="editDialog" width="600px">
      <el-form ref="editDBForm" :model="editDBForm" :rules="editDBRules">
        <el-form-item label="资源库名称：" label-width="100px">
          <el-input
            v-model="editDBForm.name"
            style="max-width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="来源：" label-width="100px">
          <el-select v-model="editDBForm.sourceId" clearable>
            <el-option
              v-for="item in sourceList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" label-width="100px">
          <el-select v-model="editDBForm.type" clearable>
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" label-width="100px">
          <el-input
            type="textarea"
            v-model="editDBForm.remark"
            style="max-width: 400px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateSource('editDBForm')"
          >确 定</el-button
        >
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认弹窗 -->
    <el-dialog title="删除资源库" :visible.sync="deleteDialog" width="600px">
      <div>确定删除该资源库</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onDelete" type="primary">确 定</el-button>
        <el-button @click="deleteDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      tableLoading: false,
      multipleSelectionTable: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      dataText: "",
      optionData: [],
      sourceList: [],
      typeList: [
        {
          label: "百科条目",
          value: 10,
        },
        {
          label: "辞典工具书",
          value: 20,
        },
        {
          label: "专项数据",
          value: 30,
        },
        {
          label: "图书",
          value: 40,
        },
        {
          label: "图片",
          value: 50,
        },
        {
          label: "音频",
          value: 60,
        },
        {
          label: "视频",
          value: 70,
        },
        {
          label: "图片集",
          value: 80,
        },
        {
          label: "音频集",
          value: 90,
        },
        {
          label: "图书",
          value: 30,
        },
        {
          label: "视频集",
          value: 100,
        },
        {
          label: "3D动画",
          value: 110,
        },
        {
          label: "论文",
          value: 120,
        },
        {
          label: "文章",
          value: 130,
        },
        {
          label: "问答对",
          value: 140,
        },
      ],
      addDBForm: {
        name: "",
        type: "",
        parentId: "",
        remark: "",
        status: "",
        sourceId: "",
        sourceInfo: {
          id: "",
          name: "",
        },
      },
      editDBForm: {
        id: "",
        name: "",
        type: "",
        parentId: "",
        remark: "",
        status: "",
        sourceId: "",
        sourceInfo: {
          id: "",
          name: "",
        },
      },
      createDialog: false,
      editDialog: false,
      deleteDialog: false,
      lockPreDialog: false,
      addDBRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
      editDBRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
  },
  methods: {
    // 加载数据
    searchParam() {
      let that = this;
      let params = {};
      params.size = this.pageSize;
      params.page = this.currentPage;
      that.tableLoading = true;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/list",
        type: "GET",
        contentType: "application/json;charset=utf-8",
        dataType: "json",
        data: params,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (response) {
          if (response.code == 200) {
            console.log(response.obj.list);
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.tableLoading = false;
            that.totalSize = response.obj.total;
            that.tableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
      this.getSourceList();
      this.addDBForm = {
        name: "",
        type: "",
        parentId: "",
        remark: "",
        status: "",
        sourceId: "",
        sourceInfo: {
          id: "",
          name: "",
        },
      };
    },
    deletePre() {
      console.log("这是删除弹窗");
    },
    // 提交创建
    onCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          $.ajax({
            url: "/zyk/c/subject/subjectInfo/add",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: that.addDBForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "新增成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑
    editSource(row) {
      this.getSourceList();
      this.editDBForm = {
        id: row[0].id,
        name: row[0].name,
        remark: row[0].remark,
        type: row[0].type,
        sourceId: row[0].sourceId,
      };
      this.editDialog = true;
    },
    // 确认修改
    updateSource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          $.ajax({
            url: "/zyk/c/subject/subjectInfo/update",
            type: "POST",
            dataType: "json",
            data: that.editDBForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "修改成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.editDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 编辑、删除、转正式前确认
    preCheck(current) {
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的组织机构",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toEdit") {
        // 编辑确认
        if (this.multipleSelectionTable.length == 1) {
          this.editSource(this.multipleSelectionTable);
        } else {
          this.$message({
            message: "请勿选择多个进行编辑",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toDelete") {
        // 删除确认
        let flag = this.multipleSelectionTable.every(function (value) {
          if (value.status == 10) {
            return true;
          }
        });
        console.log(flag);
        if (flag) {
          this.deleteDialog = true;
        } else {
          this.$message({
            message: "当前机构非停用状态，请停用后再进行删除操作",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      }
    },

    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },

    // 删除
    onDelete() {
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: ids.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.deleteDialog = false;
            that.searchParam();
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
  },
};
</script>

<style>
</style>